module.exports = __webpack_public_path__ + "img/word.d4a0f22f.png";